import { SCREEN_NAV_BAR_HEIGHT, SHEET_NAV_BAR_TOP_SPACING } from '@/components/ScreenNavBar';
import { isWeb } from '@/utils/constants-platform-specific';

export const CLOSE_ICON_SIZE = 24;
// promo pages open as sheets, so the header uses the sheet header spacing (same as the Entry screen header)
export const PROMO_HEADER_HEIGHT = SHEET_NAV_BAR_TOP_SPACING + SCREEN_NAV_BAR_HEIGHT;

// promo image row, above the title
export const PROMO_IMAGE_SIZE = 188;
export const PROMO_IMAGE_TOP_SPACING = 22;
export const PROMO_IMAGE_BOTTOM_SPACING = 18;

// can't go below 0 (on iOS, in a sheet the top inset is 0)
export const getPromoContentPaddingTop = (insetTop: number) => (isWeb ? 20 : Math.max(insetTop - 16, 0));

// how much we scroll until the title reaches the header
export const getPromoHeaderBarScrollOffset = (insetTop: number) => {
    const titleTop =
        getPromoContentPaddingTop(insetTop) + PROMO_IMAGE_TOP_SPACING + PROMO_IMAGE_SIZE + PROMO_IMAGE_BOTTOM_SPACING;
    return titleTop - (insetTop + PROMO_HEADER_HEIGHT);
};
export const TOP_GLOW_BLUR_VALUE = 100;
export const TOP_GLOW_RADIUS = 200;
export const TOP_GLOW_COLOR_OPACITY = 0.4;
export const TOP_GLOW_CIRCLE_X = 0;
export const TOP_GLOW_CIRCLE_Y = 0;

export const PROMOS_CACHE_TIME = 60 * 1000; // 1 minute
